import type { CensusPayload } from '../api/types';
import { censusFigures } from '../lib/census';
import { ApiStateText } from './ApiStateText';

export interface CensusProps {
  payload: CensusPayload | null;
  /** The census query failed or the API is off: the counters read n/a. */
  unavailable: boolean;
}

/** Official tokens, look-alike tokens and the pools holding a look-alike, from /census. */
export function Census({ payload, unavailable }: CensusProps) {
  const f = payload ? censusFigures(payload) : null;
  const value = (v: string | undefined) => v ?? (unavailable ? 'n/a' : 'loading');
  return (
    <section className="section" id="census">
      <h2>Official tokens and their look-alikes</h2>
      <dl className="readouts counter" id="census-counter" aria-label="Token census">
        <div>
          <dt>Official Stock Tokens</dt>
          <dd id="c-official">{value(f?.official)}</dd>
        </div>
        <div>
          <dt>Look-alike tokens</dt>
          <dd id="c-lookalike" className={f ? 'gap' : ''}>{value(f?.lookalike)}</dd>
        </div>
        <div>
          <dt>Pools holding a look-alike</dt>
          <dd id="c-pools" className={f ? 'gap' : ''}>{value(f?.pools)}</dd>
        </div>
      </dl>
      <p className="table-intro" id="census-sub">{f ? f.sub : 'The census needs the live API'}; live API: <ApiStateText />.</p>
      <p className="fineprint" id="census-note">{f ? `Coverage: ${f.note}.` : 'Coverage: the census counts only what the indexer has scanned; the note that states its window comes with the live answer.'}</p>
    </section>
  );
}
